<script lang="ts">
	export let fill = "#6d6f76";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 30 26.784">
	<g data-name="그룹 50141">
		<g data-name="그룹 48967">
			<path
				data-name="패스 6651"
				d="M71.858 103.251a.592.592 0 0 1-.414-.168.6.6 0 0 1-.014-.844l11.952-12.38-11.953-12.38a.6.6 0 1 1 .857-.83L84.64 89.444a.6.6 0 0 1 0 .83l-12.353 12.795a.6.6 0 0 1-.429.182z"
				transform="rotate(180 42.404 51.626)"
				style={`fill:${fill}`} />
		</g>
		<g data-name="그룹 48968">
			<path
				data-name="패스 6652"
				d="M73.15 99.086H44.344a.6.6 0 1 1 0-1.192H73.15a.6.6 0 1 1 0 1.192z"
				transform="rotate(180 36.873 55.941)"
				style={`fill:${fill}`} />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		path {
			transition: fill 0.5s;
		}
	}

</style>
